import { compareAsc, compareDesc, isSameDay, subDays } from "date-fns";

export function lessThanXDaysAgo(date: Date, days: number) {
	const daysAgo = subDays(new Date(), days);

	return compareAsc(date, daysAgo) >= 0;
}

export function greaterThanXDaysAgo(date: Date, days: number) {
	const daysAgo = subDays(new Date(), days);

	return compareDesc(date, daysAgo) >= 0;
}

export function isToday(date: Date) {
	return isSameDay(date, new Date());
}

export function isYesterday(date: Date) {
	return isSameDay(date, subDays(new Date(), 1));
}

export function parseTime(time: string | null | undefined, date: Date) {
	if (!time) {
		return undefined;
	}

	const [hours, minutes] = time.split(":").map(Number);
	const newDate = new Date(date);
	newDate.setHours(hours || 0, minutes || 0, 0, 0);
	return newDate;
}
